module.exports = __webpack_public_path__ + "img/R_HAZ_W.4b707f86.svg";